export default "__VITE_PUBLIC_ASSET__f3f4dff2__"